import React from 'react';
import Layout from './app/modules/layout/Layout';
import {Outlet} from 'react-router-dom';
import "react-datepicker/dist/react-datepicker.css";

const App: React.FC = () => {
  return (
    <Layout>
      <Outlet />
    </Layout>
  );
};

export default App;
